import { render } from "./LookupComponent.vue?vue&type=template&id=59d88a5e"
import script from "./LookupComponent.vue?vue&type=script&lang=js"
export * from "./LookupComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__